module.exports = __webpack_public_path__ + "static/media/img-container_es.1097fe88.png";